/*
 * Copyright (C) 2025 Netgem SA
 *
 * This software is the copyrighted work of Netgem and constitutes
 * confidential information.
 *
 * By using this software you agree to hold the Confidential Information in
 * strict confidence and shall not disclose such information to any third party
 * without the written permission of Netgem SA. You also agree to employ all
 * steps necessary to protect the Confidential Information from unauthorized
 * disclosure or use, including without limitation, all steps you use to protect
 * information considered proprietary and a trade secret.
 */

import Package from '@root/package.json';

export namespace ENV {
    export enum Types {
        Development = 'development',
        Production = 'production',
        Staging = 'staging',
    }

    export function isDevelopment(
        environment: ENV.Types = APP.Environment,
    ): environment is ENV.Types.Development {
        return environment === ENV.Types.Development;
    }

    export function isProduction(
        environment: ENV.Types = APP.Environment,
    ): environment is ENV.Types.Production {
        return environment === ENV.Types.Production;
    }

    export function isStaging(
        environment: ENV.Types = APP.Environment,
    ): environment is ENV.Types.Staging {
        return environment === ENV.Types.Staging;
    }
}

export namespace APP {
    export const Environment: ENV.Types = import.meta.env.MODE as ENV.Types;
    export const Version = Package.version;
}
